import Footer from "../Components/Footer";
import Header from "../Components/Header";
import ImageGallery from "./ImageGallery";
import GalleryHeader from "./Header";
import Decision from "../Components/Decision";
import { useRecoilValue } from "recoil";
import { pageDetails } from "../Recoil/ActiveEvents";
export default function Gallery() {
  const selectedEvent = useRecoilValue(pageDetails);
    return (
      <div>
        <Header />
        <GalleryHeader eventID = {selectedEvent.selectedEID}/>
        <ImageGallery />
        <Decision/>
        <Footer />
      </div>
    );
  }